import React from 'react'
import { useCallback, useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { FormattedHTMLMessage } from 'sb-react-intl'
import { constants } from 'common/helpers'
import actions from 'redux/actions'

import { Button, buttonMessages } from 'components/_new/controls'

import Title from '../Title/Title'
import Steps from './Steps/Steps'

import messages from './messages'
import s from './PlanOptions.scss'


type PlanOptionsProps = {
  goToStep: (step: string) => void
  onFirstClick: () => void
}

const PlanOptions: React.FunctionComponent<PlanOptionsProps> = (props) => {
  const { goToStep, onFirstClick } = props

  const { currPlan, activeMonthIndex, isNoteVisible, selectedPlan } = useConnect({
    currPlan: 'models.subscription.currPlan',
    activeMonthIndex: 'models.upgradeSubscriptionFlow.activeMonthIndex',
    isNoteVisible: (state) => {
      const { models: { queue: { items } } } = state

      return items.some(({ status }) => status.includes('free'))
    },
    selectedPlan: actions.models.upgradeSubscriptionFlow.getSelectedPlan,
  })

  const goNextStep = useCallback(() => {
    goToStep(constants.upgradeSubscriptionFlowSteps.selectedPlanSummary)
  }, [ goToStep ])

  const isOrderButtonVisible = useMemo(() => (
    typeof activeMonthIndex === 'number'
    && selectedPlan
    && currPlan.name !== selectedPlan.name
  ), [ activeMonthIndex, selectedPlan, currPlan ])

  return (
    <div>
      <Title className={s.title} message={messages.title} />
      {
        isNoteVisible  && (
          <FormattedHTMLMessage className={s.note} tag="div" {...messages.note} />
        )
      }
      <Steps className={s.steps} onFirstClick={onFirstClick} />
      {
        isOrderButtonVisible && (
          <Button
            className={s.orderButton}
            title={buttonMessages.orderNow}
            color="brand"
            size="md"
            dataTestId={constants.testIds.upgrade.orderButton}
            onClick={goNextStep}
          />
        )
      }
    </div>
  )
}


export default PlanOptions
